import { Injectable } from '@angular/core';
import { iWeekDay } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  public getWeekDays(day: string | Date): Array<iWeekDay> {
    const days: Array<iWeekDay> = [];

    // Ensure the input is a valid Date object
    const inputDate = new Date(day);
    if (isNaN(+inputDate)) {
      console.log("Invalid date");
      return days;
    }

    // Calculate the start of the week (Monday)
    const startOfWeek = new Date(inputDate);
    const dayOfWeek = inputDate.getDay();
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    startOfWeek.setDate(inputDate.getDate() - daysToMonday);

    // Generate the list of days in the week
    for (let i = 0; i < 7; i++) {
      const currentDay = new Date(startOfWeek);
      currentDay.setDate(startOfWeek.getDate() + i);
      //currentDay.toLocaleDateString('ru-RU', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
      days.push({
        day: currentDay.getDate(),
        weekTitle: currentDay.toLocaleDateString('ru-RU', { weekday: 'long' }),
        date: currentDay,
        times: []
      });
    }

    return days;
  }
}
